import React from 'react';
import style from './Anchor.scss';

export const Anchor = ({ id }) => {
  return <span id={id} className={style.anchor} />;
};
